__turbopack_context__.v({
  "body": "PromoBox-module-scss-module__N8dCVq__body",
  "boxContainer": "PromoBox-module-scss-module__N8dCVq__boxContainer",
  "contentContainer": "PromoBox-module-scss-module__N8dCVq__contentContainer",
  "ctaContainer": "PromoBox-module-scss-module__N8dCVq__ctaContainer",
  "heading": "PromoBox-module-scss-module__N8dCVq__heading",
  "imageContainer": "PromoBox-module-scss-module__N8dCVq__imageContainer",
  "redText": "PromoBox-module-scss-module__N8dCVq__redText",
  "secondaryPromoBox": "PromoBox-module-scss-module__N8dCVq__secondaryPromoBox",
});
